<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="true">

            <el-form-item class="form-title" prop="vc_type" label="字典类型" style="width: 350px">
                <div class="mrA">{{formData.vc_type}}</div>
            </el-form-item>
<!--            <el-form-item class="form-title" prop="vc_name" label="名称" style="width: 350px" required>-->
<!--                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.vc_name}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="vc_name_en" label="英文名称" style="width: 350px" required>-->
<!--                <el-input v-if="canEdit" v-model="formData.vc_name_en" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.vc_name_en}}</div>-->
<!--            </el-form-item>-->
            <el-form-item class="form-title"　v-for="item in data.dynamicColumn" :prop="item.prop" :label="item.label" style="width: 350px" :required="item.required">
                <template v-if="item.type=='select'">
<!--                    <el-select v-if="item.prop=='i_isweightunit'"  style="width: 100%" v-model="formData[item.prop]" filterable size="mini" :disabled="!canEdit">-->
<!--                        <el-option v-for="item in weightunitList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>-->
<!--                    </el-select>-->
                    <el-select v-if="item.prop=='i_unitgroup_id'"  :remote="true" :remote-method="unitgroupsearch" @change="unitgroupChange"  :disabled="!canEdit" style="width: 100%" v-model="formData[item.prop]" filterable size="mini">
                        <el-option v-for="item in unitGroupList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                </template>
                <template v-else-if="item.type=='radio'">
                   <el-radio-group v-if="item.prop=='i_isbaseunit'" v-model="formData[item.prop]" :disabled="!canEdit||!baseunitcanEdit" @input="radioChange(item.prop)">
                       <el-radio  :label="1">是</el-radio>
                        <el-radio  :label="0">否</el-radio>
                    </el-radio-group>
                   <el-radio-group v-else v-model="formData[item.prop]" :disabled="!canEdit" @input="radioChange(item.prop)">
                       <el-radio  :label="1">是</el-radio>
                        <el-radio  :label="0">否</el-radio>
                    </el-radio-group>
                </template>
                <template  v-else-if="item.type=='input'">
                    <el-input v-model="formData[item.prop]" size="mini" @change="inputChange($event,item.prop)" placeholder="请输入" :disabled="!canEdit"></el-input>
                </template>
                <template  v-else-if="item.type=='input-num'">
                    <el-input-number v-model="formData[item.prop]" size="mini" :controls="false" :min="item.min" :precision="0" @change="inputChange($event,item.prop)" placeholder="请输入" :disabled="!canEdit"></el-input-number>
                </template>
                <div class="mrA" v-else>{{formData[item.prop]}}</div>
            </el-form-item>
<!--            <el-form-item prop="isuse" label="是否启用" style="width: 350px" v-if="data.type=='edit'">-->
<!--                <el-radio-group v-model="formData.isuse" v-if="canEdit">-->
<!--                    <el-radio  :label="1">是</el-radio>-->
<!--                    <el-radio  :label="0">否</el-radio>-->
<!--                </el-radio-group>-->
<!--                <div class="mrA" v-else>{{formData.isuse==1?'是':'否'}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 350px" >-->
<!--                <div class="mrA" >{{formData.vc_lruname}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 350px" >-->
<!--                <div class="mrA" >{{formData.dt_createtime}}</div>-->
<!--            </el-form-item>-->
        </el-form>
        <el-table border  ref="sgtableyy" size="mini" :data="i18nList" :height="200" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
            <el-table-column
                    v-for="col in tableColumns"
                    :key="col.key"
                    :prop="col.key"
                    :label="col.vc_name"
                    align="center">
                <template #header>
                    <span class="red-star" v-if="col.required" >*</span><span>{{ col.vc_name }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row[col.key]" size="mini" v-if="canEdit&&col.key!='vc_lang'" ></el-input>
                    <span v-else>{{scope.row[col.key]}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-table border v-if="data.data.i_type==31"  ref="sgtable1" size="mini" :data="tableData" :height="300" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
            <el-table-column  prop="i_isuse" label="是否启用" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.i_isuse" :disabled="!canEdit">
                        <el-radio  :label="1">是</el-radio>
                        <el-radio  :label="-1">否</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column  prop="i_unitgroup_id" label="单位组" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_unitgroup_id" @focus="unitGrouprefresh" :remote="true" :remote-method="unitgroupsearch" @change="unitgroupChange(scope.row,scope.$index)"  :disabled="!canEdit||scope.row.i_id!=0" style="width: 100%" filterable size="mini">
                        <el-option v-for="item in unitGroupList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column  prop="i_isbaseunit" label="是否基准单位" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-radio-group  v-model="scope.row.i_isbaseunit" :disabled="!canEdit||!scope.row.baseunitcanEdit||scope.row.i_id!=0" @input="baseunitradioChange(scope.row,scope.$index)">
                        <el-radio  :label="1">是</el-radio>
                        <el-radio  :label="0">否</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_baseunit_name" label="基准单位" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="f_baseunit_convertion" label="基准单位转换率" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input-number :controls="false" :min="0" v-model="scope.row.f_baseunit_convertion" size="mini" placeholder="请输入" :disabled="!canEdit||scope.row.i_id!=0"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column :label="$t('form_operate')" width="40" align="center">
                <template slot="header" slot-scope="scope" v-if="canEdit">
                    <el-button  icon="el-icon-plus"  @click="addRow"   size="mini" v-if="canEdit" type="text" ></el-button>
                </template>
                <template slot-scope="scope">
                    <el-button  icon="el-icon-minus" type="text"  v-if="canEdit&&scope.row.i_id==0" @click="deleteRow(scope.row,scope.$index)"  size="mini"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import {language} from '@/locales/selection'

    export default {
        name: "AddPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    vc_name_en:'',
                    i_type:'',
                },
                canEdit:false,
                disabled:false,
                dzList:[],
                unitGroupList:[],
                rules:{
                    vc_name:[{required: true,message:'名称不能为空'}],
                    vc_ename:[{required: true,message:'英文名称不能为空'}],
                },
                weightunitList:[{i_id:1,vc_name:'重量单位'},{i_id:2,vc_name:'面积单位'},{i_id:3,vc_name:'体积单位'},{i_id:4,vc_name:'长度单位'},{i_id:5,vc_name:'计件'},],
                unitGroup_search:'',
                tableData:[],
                langList:language,
                _i18nList:null,
                // baseunitcanEdit:true,

            }
        },
        computed: {
            tableColumns() {

                // 2. 基础固定字段（始终展示）
                const baseFixedList = [
                    // { vc_name: 'ID', key: 'i_id' },
                    { vc_name: '语言', key: 'vc_lang',required: true  },
                    { vc_name: '名称', key: 'vc_name' ,required: true},
                ];

                // 3. 条件固定字段（仅当 i_type == 3 时追加）
                const extraFixedList = [
                    { vc_name: '简写', key: 'vc_sname' ,required: true},
                    { vc_name: '展示名称', key: 'vc_showname',required: true }
                ];

                // 4. 组合并返回
                if (this.data.data.i_type==3) {
                    // 如果类型是3，把基础字段和额外字段拼接起来
                    return baseFixedList.concat( extraFixedList);
                } else {
                    // 否则，只返回基础字段
                    return baseFixedList;
                }
            },
            i18nList: {

                // 1. 获取值时的逻辑（新增时走这里）
                get() {
                    // 1. 永远以 langList 为基准，确保始终生成 4 行
                    return this.langList.map(lang => {
                        // 2. 尝试从接口数据中查找当前语言的数据
                        // 假设接口返回的数据中，语言标识字段也是 vc_lang
                        const existingRow = this._i18nList?.find(
                            item => item.vc_lang === lang.i_id
                        );

                        // 3. 如果找到了，使用接口数据；否则，生成默认空数据
                        if (existingRow) {
                            // 注意：这里最好返回一个新对象，避免直接修改接口原始数据
                            return { ...existingRow };
                        } else {
                            // 走你原本的新增逻辑
                            const row = {
                                vc_name: '',
                                vc_lang: lang.i_id
                            };
                            if (this.i_type == 3) {
                                row.vc_sname = '';
                                row.vc_showname = '';
                            }
                            return row;
                        }
                    });
                },
                set(newValue) {
                    // 当执行 this.i18nList = xxx 时，会触发这里
                    // 将新值赋给本地的响应式变量
                    this._i18nList = newValue;
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        beforeMount(){
            if(this.data.type=='add'){
                this.canEdit=true;
                this.formData = this.data.dynamicColumn.reduce((acc, { prop }) => {
                    if(prop=='c_ordertype'||prop=='i_isbaseunit'){
                        acc[prop] = 0;
                    }else if(prop=='vc_fymx_yycode'){
                        acc[prop] = acc['i_fypid'];
                    }else{
                        acc[prop] = ''; // 将 prop 作为键，值初始化为空字符串
                    }
                    return acc;
                }, {});
                this.formData.i_type=this.data.data.i_type;
                this.formData.vc_type=this.data.data.vc_name;
                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                this.formData=JSON.parse(JSON.stringify(this.data.data));
                // if(this.formData.i_isbaseunit==1){
                //     this.formData.vc_baseunit_name=this.formData.vc_name
                // }
                this.i18nList=this.formData.i18nList
                if(this.data.data.i_type==31){
                    this.tableData=this.formData.unitGroupList
                    this.table&&this.tableData.map(a=>{
                        if(a.i_baseunit_id){a.baseunitcanEdit=false}
                        // else{
                        //     a.baseunitcanEdit=true
                        // }
                    })
                }
            }
            // console.log(this.formData,'i18nList',this.data)
        },
        mounted() {
            this.getUnitGroupList()

            this.baseerp = baseerp;
            // this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });



        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            cancel(){
                this.$emit('close')
            },
            addRow(row,index){
                this.tableData.unshift({
                    i_id:0,
                    i_isuse:1,
                    i_unitgroup_id:'',
                    i_isbaseunit:0,
                    vc_baseunit_name:"",
                    f_baseunit_convertion:1,
                    baseunitcanEdit:true,

                })
            },
            deleteRow(row,index){
                this.tableData.splice(index,1);
                // if(row.id!=0)this.formData.delgoods.push(row.id);
                // this.getSum(row,index)
            },
            inputChange(e,type){
                // console.log(e,type,'inputChange')
                if(type=='vc_name'){
                    this.$set(this.i18nList[0],'vc_name',e)
                }else if(type=='vc_name_en'){
                    this.$set(this.i18nList[1],'vc_name',e)

                }else if(type=='vc_showname'){
                    this.$set(this.i18nList[0],'vc_showname',e)

                }else if(type=='vc_sname'){
                    this.$set(this.i18nList[0],'vc_sname',e)

                }
                if(type=='i_fypid'){
                    this.$set(this.formData,'vc_fymx_yycode',this.formData.i_fypid)

                }
            },
            radioChange(type){
            },
            baseunitradioChange(row,index){
                if(row.i_isbaseunit==1){
                    this.$set(this.tableData[index],'vc_baseunit_name',this.formData.vc_name);
                    this.$set(this.tableData[index],'i_baseunit_id',this.formData.i_id);
                }else{
                    let obj=this.unitGroupList.find(g=>g.i_id==row.i_unitgroup_id);
                    if(row.i_unitgroup_id&&obj){
                        this.$set(this.tableData[index],'vc_baseunit_name',obj.vc_baseunit_name);
                        this.$set(this.tableData[index],'i_baseunit_id',obj.i_baseunit_id);
                        if(obj.i_baseunit_id){this.tableData[index].baseunitcanEdit=false}
                // else{
                //             this.tableData[index].baseunitcanEdit=true
                //         }
                    }else{
                        this.tableData[index].baseunitcanEdit=true
                        this.$set(this.tableData[index],'vc_baseunit_name','')
                        this.$set(this.tableData[index],'i_baseunit_id','')
                    }
                }
            },
            save(formName){
                // console.log(this.formData,'formData',formName)

                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        let b=this.tableData.filter(t=>!t.i_unitgroup_id);
                        if(b.length>0){
                            this.$message.warning('请选择单位组')
                            return
                        }
                        let a=this.tableData.filter(t=>t.f_baseunit_convertion==0);
                        if (a.length>0){
                            this.$message.warning('基准单位转换率不能为0');
                            return
                        }
                        for (let i = 0; i < this.i18nList.length; i++) {
                            const row = this.i18nList[i];

                            // 2. 遍历表头配置，找出所有 required: true 的字段
                            for (const col of this.tableColumns) {
                                if (col.required) {
                                    // 3. 获取当前行对应字段的值
                                    const value = row[col.key];

                                    // 4. 判断是否为空（兼容 null, undefined, 空字符串, 纯空格）
                                    if (value === null || value === undefined || String(value).trim() === '') {
                                        // 5. 发现空值，弹出友好提示并终止提交
                                        this.$message.warning(`第 ${i + 1} 行的【${col.vc_name}】不能为空！`);
                                        return; // 直接中断方法，不往下执行
                                    }
                                }
                            }
                        }
                        let i18nList=this.i18nList.map(item => ({
                            ...item,
                            i_pid: this.formData.i_id
                        }));
                        let param=this.formData;
                        param.unitGroupList=this.tableData;
                        param.i18nList=i18nList;
                        // console.log(param,'param')
                        if(this.data.type=='add'){
                            this.addItem(param)
                        }else{
                            this.editItem(param)
                        }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                // this.getUnitGroupList()

            },
            //新增
            async addItem(val){
                this.disabled=true
                let param=val;
                let res=await API.addItem(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.disabled=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            //编辑
            async editItem(val){
                this.disabled=true;
                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                // console.log(i18nList,'i18nList')
                let param=val;
                let res=await API.editItem(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.disabled=false;
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            unitgroupChange(row,index){
                if(row.i_unitgroup_id){
                    // if(this.formData.i_isbaseunit==1){
                    //     this.$set(this.formData,'vc_baseunit_name',this.data.data.vc_name)
                    //     this.$set(this.formData,'i_baseunit_id',this.data.data.i_id)
                    //     // this.formData.vc_baseunit_name==this.formData.vc_name
                    //     // this.formData.i_baseunit_id=this.formData.i_id
                    // }else{
                        let obj=this.unitGroupList.find(g=>g.i_id==row.i_unitgroup_id)
                    if(obj.i_baseunit_id){
                        this.$set(this.tableData[index],'vc_baseunit_name',obj.vc_baseunit_name)
                        this.$set(this.tableData[index],'i_baseunit_id',obj.i_baseunit_id)
                        this.$set(this.tableData[index],'i_isbaseunit',0)
                        this.tableData[index].baseunitcanEdit=false
                        // this.formData.i_isbaseunit==1
                    }else{
                        this.tableData[index].baseunitcanEdit=true
                        if(row.i_isbaseunit==1){
                            this.$set(this.tableData[index],'vc_baseunit_name',this.formData.vc_name)
                            this.$set(this.tableData[index],'i_baseunit_id',this.formData.i_id)
                        }else{
                            this.$set(this.tableData[index],'vc_baseunit_name','')
                            this.$set(this.tableData[index],'i_baseunit_id','')
                        }
                    }

                    // }
                    // console.log(obj,'obj')
                }
                else{
                    this.$set(this.tableData[index],'vc_baseunit_name','')
                    this.$set(this.tableData[index],'i_baseunit_id','')
                }
                // console.log(this.formData)
                this.$forceUpdate()
            },
            unitGrouprefresh(){
                this.unitGroup_search='';
                this.getUnitGroupList();
            },
            unitgroupsearch(e){
                this.unitGroup_search=e;
                this.getUnitGroupList();
            },
            async getUnitGroupList(){
                let param={
                    i_isuse:1,
                    vc_search:this.unitGroup_search,
                    pageSize: 20,
                    currentPage:1
                };
                let res=await API.getUnitGroupList(param);
                if ( res.code == 1 ){
                    this.unitGroupList=res.data.list;
                    this.total=res.data.total;
                    // let obj=this.unitGroupList.find(g=>g.i_id==this.formData.i_unitgroup_id)
                    // this.formData.vc_baseunit_name=obj.vc_baseunit_name
                    // this.formData.i_baseunit_id=obj.i_baseunit_id
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }
    .el-radio{
        margin-right: 5px !important;
    }
    .red-star{
        color: red;
    }
</style>